export class Utilities {
  static escapeHTML(unsafe): string {
    if (unsafe == null) return 'null';
    if (!(typeof unsafe === 'string')) unsafe = '' + unsafe;
    return unsafe
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  static linebreakTextToHTML(text: string): string {
    return text.replace(/(\r)?\n/g, '<br />');
  }
}
